import React, { useEffect, useState } from "react";
import _ from "lodash";
import MediaObject from "./MediaObject";
import { Box, Stack, Typography } from "@mui/material";
import DisplayMediaObjects from "../MediaObject/DisplayMediaObjects";
import ExpandableList from "../ExpandableList/ExpandableList";
import { queryKeys } from "../../services/ReactQuery/reactQueryService";
import { useQueryClient } from "@tanstack/react-query";
import { MediaObject as MediaObjectType } from "../../types/MediaObject";
import MediaObjectPopUpMenu from "./MediaObjectPopUpMenu";

type MediaObjectListViewProps = {
  mediaObjects: MediaObjectType[];
};

export default function MediaObjectListView({ mediaObjects }: MediaObjectListViewProps) {
  const [mediaObjectToPreview, setMediaObjectToPreview] = useState<MediaObjectType | null>(null);
  const queryClient = useQueryClient();

  const handleSetMediaObjectToPreview = (mediaObject: MediaObjectType) => {
    setMediaObjectToPreview(mediaObject);
  };

  useEffect(() => {
    if (mediaObjectToPreview) {
      setMediaObjectToPreview(mediaObjects.find((mediaObjects) => mediaObjects.id === mediaObjectToPreview.id) ?? null);
    }
  }, [mediaObjects]);

  const refreshMediaObjects = async () => {
    await queryClient.invalidateQueries({
      queryKey: queryKeys.collections("media_objects")
    });
  };

  return (
    <>
      <ExpandableList
        items={mediaObjects}
        renderItems={(mediaObjectsToDisplay) =>
          mediaObjectsToDisplay.length > 0 ? (
            _.map(mediaObjectsToDisplay, (mediaObject) => (
              <Box key={mediaObject.id} sx={{ marginBottom: "2rem" }}>
                <MediaObject
                  mediaObject={mediaObject}
                  updateMediaObjects={refreshMediaObjects}
                  handleOpenMediaObject={handleSetMediaObjectToPreview}
                />
              </Box>
            ))
          ) : (
            <Box sx={{ textAlign: "center", color: "#dcdcdc", margin: "2rem" }}>
              <Typography variant={"h4"}>Es sind noch keine Dokumente vorhanden</Typography>
            </Box>
          )
        }
      />
      <DisplayMediaObjects
        setMediaObjectToDisplay={setMediaObjectToPreview}
        mediaObjects={mediaObjects}
        mediaObjectToDisplay={mediaObjectToPreview}
        titleElement={
          mediaObjectToPreview ? (
            <Stack
              direction={"row"}
              spacing={2}
              sx={{
                justifyContent: "flex-end",
                flexGrow: 1
              }}>
              <MediaObjectPopUpMenu mediaObject={mediaObjectToPreview} updateMediaObjects={refreshMediaObjects} />
            </Stack>
          ) : null
        }
      />
    </>
  );
}
